import { doc, setDoc, getDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { db } from './config';
import { UserProfile } from '../types/user';

export const setupAdminUser = async (uid: string = 'L5Z5XWmtW4XUR3hD4c2WBJayWeK2') => {
  const userRef = doc(db, 'users', uid);
  const userDoc = await getDoc(userRef);
  const auth = getAuth();
  const authUser = auth.currentUser;
  
  if (userDoc.exists()) {
    const userData = userDoc.data() as UserProfile;
    await setDoc(userRef, {
      ...userData,
      isAdmin: true,
      plan: 'premium',
      email: authUser?.email || userData.email // Garde l'email existant si pas d'auth user
    });
  } else {
    // Créer un profil admin par défaut si inexistant
    const adminProfile: UserProfile = {
      uid,
      email: authUser?.email || 'atelier.davai@gmail.com', // Email par défaut si pas d'auth user
      username: authUser?.email?.split('@')[0] || 'Admin',
      isAdmin: true,
      plan: 'premium',
      language: 'fr',
      timezone: 'Europe/Paris',
      registrationDate: new Date().toISOString(),
      lastLoginDate: new Date().toISOString(),
    };
    await setDoc(userRef, adminProfile);
  }
  
  console.log('Admin user setup completed');
};
